import { ApiProject, ApiSessionEffectivenessRule } from "@incendium/api";
import { sessionEffectivenessRuleService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchSessionEffectivenessRules = async (project: ApiProject) => {
  const res = await sessionEffectivenessRuleService.sessionEffectivenessRuleServiceListRules({
    projectId: project.id as number,
  });
  return res.results || [];
};

export const useSessionEffectivenessRules = () => {
  const { state, setState } = useProjectSharedState(
    "sessionEffectivenessRules",
    [],
    fetchSessionEffectivenessRules
  );

  return {
    sessionEffectivenessRules: state as ApiSessionEffectivenessRule[],
    setSessionEffectivenessRules: setState,
  };
};
